import React, { useState } from 'react'
import Image from '../atoms/Image'
import { ProductSimple } from '@interfaces/product'
import ColorDot from '../atoms/ColorDot'

interface ProductProps {
  product: ProductSimple
  collectionTitle?: string
  onDeleteAndReplace: () => void
  className?: string
}

const ProductCardSimple: React.FC<ProductProps> = ({ product, collectionTitle, onDeleteAndReplace, className }) => {
  const { title, price, handle, variants, priceVaries, priceMin, priceMax } = product
  const [currentVariant] = useState(variants?.[0] || {})
  const handleRedDotClick = () => {
    onDeleteAndReplace()
  }

  return (
    <div className={className}>
      <div className="relative rounded overflow-hidden aspect-square">
        <div className="absolute z-2 top-0 left-0 right-0 bg-gradient-metal border-b border-grey-2">
          <div className="flex items-center gap-x-1 py-1.5 px-1 md:p-1.5">
            <ColorDot colorType="red" onClick={handleRedDotClick} />
            <ColorDot colorType="yellow" />
            <ColorDot colorType="green" />
          </div>
        </div>
        <a href={`/products/${handle}`} className="absolute inset-0 z-1 bg-white flex mt-4" aria-label={title}>
          {currentVariant.image?.src ? (
            <Image
              alt={currentVariant.image.alt}
              src={currentVariant.image.src}
              srcWidths={{ sm: 640 }}
              height={800}
              width={640}
              wrapperClasses="w-full h-full object-contain"
              classes="w-full h-full object-contain"
            />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: product.placeholder_svg }} className="w-full h-full bg-white" />
          )}
        </a>
      </div>
      <div>
        {title && <h3 className="body-md font-bold mt-3 lg:mt-4">{title}</h3>}
        {collectionTitle && <p className="body-xs">{collectionTitle}</p>}
        {priceVaries ? (
          <p className="body-lg font-bold mt-2">
            {priceMin} - {priceMax}
          </p>
        ) : (
          <p className="body-lg font-bold mt-2">{price}</p>
        )}
      </div>
    </div>
  )
}

export default ProductCardSimple
